import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { GetMimumVersionMapper } from "@app/core/version/data/network/get-minimum-mapper";
import { AppVersion } from "@app/core/version/domain/model/app-version";

@Injectable({
  providedIn: "root",
})
export class GetMinimumVersionWS {
  constructor(private handler: BaseHandler) {}
  execute(): Observable<AppVersion> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_MINIMUM_APP_VERSION_ENDPOINT())
      .setMethod(HttpMethod.get)
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => GetMimumVersionMapper.deserialize(response)));
  }
}
